import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page-wrapper">
      <div className="container">
        <div className="privacy-card">
          
          {/* Header */}
          <header className="privacy-header">
            <h1 className="privacy-title">Privacy Policy</h1>
            <div className="privacy-meta">
              <span className="last-updated">Effective Date: March 5, 2025</span>
            </div>
          </header>

          <div className="privacy-content">
            <section className="policy-section">
              <h2 className="section-heading">1. Introduction</h2>
              <p>
                Welcome to <strong>arthroscopydoc.com</strong>, operated by Dr. Sunil Apsingi.
                Your privacy is important to us. This Privacy Policy outlines the types of
                information we collect, how we use it, and how we protect your information.
              </p>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">2. Information We Collect</h2>
              <p className="mb-2">We may collect the following types of data:</p>
              <ul className="policy-list">
                <li><strong>Personal Information:</strong> Name, email address, and phone number (only when voluntarily provided via forms).</li>
                <li><strong>Non-Personal Information:</strong> Browser type, IP address, device type, and pages visited.</li>
                <li><strong>Analytics:</strong> Cookies and tracking technologies to understand website traffic patterns.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">3. How We Use Your Information</h2>
              <ul className="policy-list">
                <li>To improve website functionality and user experience.</li>
                <li>To communicate with you regarding appointments or inquiries.</li>
                <li>To analyze website traffic and trends to better serve our patients.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">4. Information Sharing</h2>
              <p>
                We <strong>do not sell, trade, or share</strong> your personal data with third parties, except when required
                by law or to improve our services (such as trusted analytics providers who are bound by confidentiality).
              </p>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">5. Security</h2>
              <p>
                We take reasonable administrative and technical measures to protect your data against unauthorized access. 
                However, please note that no method of transmission over the internet is 100% secure.
              </p>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">6. Your Rights</h2>
              <p>
                You have the right to access, update, or request the deletion of your personal data held by us.
                Please contact us directly for any such requests.
              </p>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">7. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically to reflect changes in our practices. 
                We encourage you to review this page for the latest information.
              </p>
            </section>

            <section className="policy-section">
              <h2 className="section-heading">8. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:
              </p><a href="mailto:sunilapsingi@arthroscopydoc.com" className="contact-link">
                sunilapsingi@arthroscopydoc.com
              </a>
            </section>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;